import { BUSCAR_RESERVAS_ITINERARIO, LIMPAR_RESERVAS_ITINERARIO, ALTERAR_RESERVA_ITINERARIO, ALTERAR_TODAS_RESERVAS_ITINERARIO } from '../../actions/types'

const initialState = {
    reservas: []
}

export default function reducerTransferenciaReservasItinerario(state = initialState, action = initialState) {
    switch (action.type) {
        case BUSCAR_RESERVAS_ITINERARIO: {
            let reservas = action.payload.data;
            if (reservas) {
                reservas = reservas.map(reserva => Object.assign({}, reserva, { marcado: false }));
                return {
                    ...state,
                    reservas
                }
            }
            return state
        }

        case LIMPAR_RESERVAS_ITINERARIO: {
            return initialState
        }

        case ALTERAR_RESERVA_ITINERARIO: {
            const reserva = action.payload;
            const indice = state.reservas.indexOf(reserva);
            const novaReserva = Object.assign({}, reserva, { marcado: !reserva.marcado });
            const reservas = Object.assign([], state.reservas);
            reservas[indice] = novaReserva;
            return {
                ...state,
                reservas
            }
        }

        case ALTERAR_TODAS_RESERVAS_ITINERARIO: {
            const reservas = state.reservas.map(reserva => Object.assign({}, reserva, { marcado: action.payload }));
            
            return {
                ...state,
                reservas
            }
        }

        default: {
            return state
        }
    }
}